import { useQuery } from "@apollo/client";
import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import {
  useDropdownOptions,
  useDropdownSelection,
  useQueryItems,
} from "../shared/dropdownUtils";
import "./dropdownSelect.scss";

const DropdownSelectComponent = (props) => {
  const { handleChange, label, path, required, visible, data, uischema, enabled } =
    props;

  const {
    query,
    variables = {},
    dataKey = "items",
    labelKey = "name",
    valueKey = "id",
    readonly,
    disabled,
    placeholder,
    selection = "single",
  } = uischema.options || {};

  const { data: queryData } = useQuery(query, { variables });

  // Use shared utility hooks
  const items = useQueryItems(queryData, dataKey);
  const options = useDropdownOptions(items, valueKey, labelKey);
  const [selected, handleSelect] = useDropdownSelection(
    data,
    options,
    selection,
    handleChange,
    path
  );

  if (!visible) return null;

  return (
    <div className="dropdown-select-component multiple-select-wrap">
      <Dropdown
        childList={options}
        selection={selection}
        label={label}
        disabled={
          enabled === false ||
          uischema?.readOnly ||
          uischema?.readonly ||
          uischema?.disabled ||
          readonly ||
          disabled ||
          uischema?.options?.readonly ||
          uischema?.options?.disabled
        }
        selectedValue={selected}
        isRequired={required}
        setSelectedValue={handleSelect}
        placeholder={placeholder || ""}
      />
    </div>
  );
};

export const DropdownSelectControl = withJsonFormsMultiEnumProps(
  DropdownSelectComponent
);
